import React, { useState, useEffect } from 'react';
// import styles from './AdvancedInstitutionalControls.module.scss';
import styles from '../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import AdvancedInstitutionalBrownfield from './AdvancedInstitutionalBrownfield/AdvancedInstitutionalBrownfield';
import AdvancedInstitutionalRCRA from './AdvancedInstitutionalRCRA/AdvancedInstitutionalRCRA';
import AdvancedInstitutionalSuperfundNPL from './AdvancedInstitutionalSuperfundNPL/AdvancedInstitutionalSuperfundNPL';
import AdvancedNoFilterOptions from '../AdvancedNoFilterOptions/AdvancedNoFilterOptions'


const AdvancedInstitutionalControls = (props) => {
  const [brownfieldParams, setBrownfieldParams] = useState<Array<string>>([]);
  const [rcraParams, setRCRAParams] = useState<Array<string>>([]);
  const [superfundNPLParams, setSuperfundNPLParams] = useState<Array<string>>([]);

  const updateBrownfieldParams = (paramArray) => {
    setBrownfieldParams(paramArray);
  }

  const updateRCRAParams = (paramArray) => {
    setRCRAParams(paramArray);
  }

  const updateSuperfundNPLParams = (paramArray) => {
    setSuperfundNPLParams(paramArray);
  }

   // updates the institutional Parameters and passes it to AdvancedCleanupsFilter
   const updateAllInstitutionalParams = () => {
    const paramArray: Array<string> = [
      ...brownfieldParams,
      ...rcraParams,
      ...superfundNPLParams
    ];
    props.updateInstitutionalParams(paramArray);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { updateAllInstitutionalParams(); }, [brownfieldParams, rcraParams, superfundNPLParams]);

  useEffect(() => { }, [props.signalClear]);

  return (
    <>
      <div className={styles.SectionContainers}>
        <div className={styles.QuarterSections}>
          <AdvancedInstitutionalBrownfield sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateBrownfieldParams={updateBrownfieldParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedInstitutionalRCRA sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateRCRAParams={updateRCRAParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedInstitutionalSuperfundNPL sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateSuperfundNPLParams={updateSuperfundNPLParams} />
        </div>
        <div className={styles.QuarterSections}>
          <AdvancedNoFilterOptions />
        </div>
      </div>
    </>
  );
}

export default AdvancedInstitutionalControls;
